import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import React, { useContext } from "react";
import { Edit, Plus } from "react-feather";
import { Card, CardHeader, Col, Row } from "reactstrap";
import { MuiTabelStyle, SHIPPING_MASTER } from "../../constant";
import ShippingMasterContext from "../../context/ShippingMasterContext/ShippingMasterContext";
import DataNotFound from "../../DataNoteFound/DataNotFound";

const ShopingMasterItem = (props) => {
  const {
    AddModel,
    editHandle,
    sorting,
    setPage,
    setPageSize,
    pageSize,
    page,
    record,
  } = props;

  const { shippValue } = useContext(ShippingMasterContext);

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 130,
      field: "shippingId",
      headerName: "ID",
    },
    {
      flex: 0.1,
      minWidth: 130,
      field: "companyName",
      headerName: "COMPANY NAME",
    },
    {
      flex: 0.15,
      minWidth: 500,
      field: "trackingLink",
      headerName: "LINK",
      renderCell: (params) => (
        <a
          href={params.row.trackingLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {params.row.trackingLink}
        </a>
      ),
    },
    {
      flex: 0.1,
      minWidth: 230,
      field: "createdAt",
      headerName: "CREATED AT",
      renderCell: (params) =>
        moment(params.row.createdAt).format("DD MMM, YYYY HH:mm"),
    },
    {
      field: "actions",
      headerName: "ACTIONS",
      sortable: false,
      renderCell: (params) => (
        <button
          className="_edit"
          type="button"
          style={{
            background: "none",
            textDecoration: "none",
            border: "none",
            // color: "#51bb25",
            color: "#7366ff",
          }}
          onClick={() => editHandle(params.row.shippingId)}
        >
          <Edit style={{ width: "19px" }} />
        </button>
      ),
    },
  ];
  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <CardHeader
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <h5>{SHIPPING_MASTER.PERENT}</h5>
              <button
                type="button"
                style={{ border: "none", background: "none" }}
                onClick={AddModel}
              >
                <div
                  style={{
                    width: "50px",
                    background: "#7366ff",
                    borderRadius: "19rem",
                    color: "white",
                  }}
                >
                  <h1>
                    <Plus />
                  </h1>
                </div>
              </button>
            </CardHeader>
            <Box
              sx={{
                "& .even": {
                  backgroundColor: "#f1f1f1",
                },
                "& .odd": {
                  backgroundColor: "white",
                },
              }}
            >
              {shippValue.length && shippValue.length ? (
                <DataGrid
                  autoHeight
                  pagination
                  sx={MuiTabelStyle}
                  rows={shippValue}
                  rowCount={record}
                  pageSize={pageSize}
                  getRowId={(row) => row.shippingId}
                  columns={defaultColumns}
                  page={page - 1}
                  rowsPerPageOptions={[7, 10, 25, 50]}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  onPageChange={(newPageNo) => setPage(newPageNo + 1)}
                  paginationMode="server"
                  disableSelectionOnClick
                  checkboxSelection={false}
                  sortingMode="server"
                  onSortModelChange={sorting}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
                  }
                />
              ) : (
                <DataNotFound />
              )}
            </Box>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ShopingMasterItem;
